var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useReducer, useRef, useState } from 'react';
import { isEqual } from 'lodash';
import { useInteractiveCanvasHelpers } from '../canvas/useInteractiveCanvasHelpers';
import { initializeDiagramState, interactiveDiagramReducer } from './interactiveDiagramReducer';
export var useInteractiveDiagramBag = function () {
    var _a = useReducer(interactiveDiagramReducer(), undefined, initializeDiagramState), state = _a[0], dispatch = _a[1];
    var initialState = useRef(state);
    var dirty = !isEqual(initialState.current, state);
    // Canvas (pan, zoom, etc.)
    var setTransform = useCallback(function (newTransform) {
        dispatch({
            type: 'SET_TRANSFORM',
            payload: newTransform,
        });
    }, []);
    var moveNode = useCallback(function (nodeId, dx, dy) {
        dispatch({
            type: 'MOVE_NODE',
            payload: { nodeId: nodeId, dx: dx, dy: dy },
        });
    }, []);
    var canvasHelpers = useInteractiveCanvasHelpers(state.transform, setTransform);
    var setValues = useCallback(function (values, reinitialize) {
        var newState = initializeDiagramState(values);
        canvasHelpers.resetCanvasTransform(newState.transform);
        if (reinitialize) {
            initialState.current = newState;
        }
        dispatch({
            type: 'SET_VALUES',
            payload: newState,
        });
    }, []);
    // Keep NodeShapes in context in separate state
    // We want them in context because Links need both their Node's NodeShape to render correctly
    // We don't want them in the main reducer just to simplify loading/saving etc., as the NodeShapes are not saved or shared outside
    var _b = useState({}), nodeShapes = _b[0], setNodeShapes = _b[1];
    var addNodeShapeToContext = useCallback(function (id, shape) {
        setNodeShapes(function (prevNodeShapes) {
            var _a;
            return (__assign(__assign({}, prevNodeShapes), (_a = {}, _a[id] = shape, _a)));
        });
    }, []);
    return {
        state: state,
        setState: setValues,
        initialState: initialState.current,
        internalHelpers: {
            dirty: dirty,
            moveNode: moveNode,
            canvasHelpers: canvasHelpers,
            nodeShapes: nodeShapes,
            addNodeShapeToContext: addNodeShapeToContext,
        }
    };
};
//# sourceMappingURL=interactiveDiagramState.js.map